import request from '@/utils/request'

// 根据token获取用户信息
export function getUserInfo () {
  return request({
    url: '/api/zauser/findZaUserByToken',
    method: 'post'
  })
}

// 登出用户
export function logOut () { // 登出
  return request({
    url: '/api/zauser/loginZaUserOut',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js